import { StateSubject } from './state-subject';
import { RegisterStage } from '../interfaces/register-stage.model';

export class RegisterStageState extends StateSubject<RegisterStage>
{
  constructor()
  {
    const defaults: Required<RegisterStage> = {
      userId: null,
      step: null,
    };
    super(defaults);
  }}
